<div id="content">
  <button class = "filterbutton" (click) = "openFilters()" i18n=":n@@itemslist.filters">Filters</button>
  <div id="listContent">
    <h1 i18n=":n@@itemslist.inventory">Inwentarz</h1>
    <table style="width:100%">
      <thead>
        <tr>
          <th (click)='sortList(fieldType.Description)' i18n=":n@@itemslist.name">Nazwa</th>
          <!--th (click)='sortList(fieldType.Mark)'  i18n=":n@@itemslist.Mark">Marka</th-->
          <!--th (click)='sortList(fieldType.Category)' i18n=":n@@itemslist.Category">Kategoria</th-->
          <!--th [hidden]="getType() === 'commercial'"i18n=":n@@itemslist.Description">Opis</th-->
          <!--th [hidden]="getType() === 'commercial'"i18n=":n@@itemslist.UserName">Imię</th-->
          <!--th [hidden]="getType() === 'commercial'"i18n=":n@@itemslist.UserSurname">Nazwisko</th-->
          <th (click)='sortList(fieldType.UserName)' i18n=":n@@itemslist.UserName">Imię</th>
          <th (click)='sortList(fieldType.UserSurname)' i18n=":n@@itemslist.UserSurname">Nazwisko</th>
          <th (click)='sortList(fieldType.LastEntry)' i18n=":n@@itemslist.lastentry">Ostatni wpis</th>
          <th (click)='sortList(fieldType.Location)' i18n=":n@@itemslist.location">Lokalizacja</th>
          <!--th [hidden]="getType() === 'commercial'"  i18n=":n@@itemslist.state">Stan</th-->
          <th (click)='sortList(fieldType.State)' i18n=":n@@itemslist.quantity">Ilość</th>
          <th (click)='sortList(fieldType.Status)' i18n=":n@@itemslist.inventory">Inwentaryzacja</th>
          <th (click)='sortList(fieldType.Remarks)' i18n=":n@@itemslist.remarks">Uwagi</th>

        </tr>
      </thead>
        <tbody>
          <tr id="itemsTable" *ngFor = "let item of items" (click)="clicktest(item.TAG_UID)">
            <td>{{getNameColumnData(item)}}</td>
            <td>{{item.USERNAME}}</td>
            <td>{{item.USERSURNAME}}</td>
            <!--td [hidden]="getType() === 'commercial'">{{item.DESCRIPTION}}</td-->
            <!--td [hidden]="getType() === 'commercial'">{{item.USERNAME}}</td-->
            <!--td [hidden]="getType() === 'commercial'">{{item.USERSURNAME}}</!--td-->
            <td>{{getLocaleDate(item.EDIT_DATETIME)}}</td>
            <td>{{item.LOCATION}}</td>
            <td>{{item.STATE}}</td>
            <td id="tdCenter" appStatusinfo status="{{item.STATUS}}"></td>
            <td>{{item.REMARKS}}</td>
          </tr>
        </tbody>
      </table>
  </div>
</div>
